import { Component, OnInit } from '@angular/core';
import { CostingcheckerService } from './costingchecker.service';

@Component({
  selector: 'app-costingchecker',
  templateUrl: './costingchecker.component.html',
  styleUrls: ['./costingchecker.component.scss']
})
export class CostingcheckerComponent implements OnInit {
  costingCheckerData: any;
  loading: boolean = true;
  email: any;

  constructor(private CostingcheckerService: CostingcheckerService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getCostingCheckerData()
  }

  getCostingCheckerData() {
    this.CostingcheckerService.getCostingCheckerLogData(this.email).subscribe((response) => {
      this.costingCheckerData = response["data"];
      console.log("resss", this.costingCheckerData);
      this.loading = false;

    });
  }

}
